import { useMutation } from '@tanstack/react-query'
import { FileService } from '../services/FileService'

interface GetBrokeNotificationUploadUrlParams {
	fileExtension?: string
}

export default function useMutationGetBrokeNotificationUploadUrl() {
	return useMutation({
		mutationFn: ({
			fileExtension = 'webp',
		}: GetBrokeNotificationUploadUrlParams) =>
			FileService.getBrokeNotificationUploadUrl(fileExtension),
	})
}
